module.exports = __webpack_public_path__ + "img/af.678dc292.png";